import { FC, useContext, useState } from "react";

import AddNote from "../modals/addNote";

import { KamFamNoteProps } from "./types";
import { AuthContext } from "src/context/authContext";
// import { useLocation, useNavigate } from "react-router-dom";
// import { AuthContext } from "src/context/authContext";
// import { handleNavigation } from "src/helpers";



const KAMFAMNotes: FC<KamFamNoteProps> = ({ caseId, kamfamNotes, add_note, updateKamfamNotes, refreshListing }): JSX.Element => {
  const [isNoteModalVisible, setNoteModalVisibility] = useState<boolean>(false);
  // const location = useLocation();
  // const navigate = useNavigate();
  const { isManufacturer } = useContext(AuthContext);

  // const redirectDecision = () => {
  //   const isRedirectRequired = handleNavigation(defaultView, location.pathname);
  //   if (isRedirectRequired) {
  //     navigate(defaultView.includes("/") ? defaultView : `/${defaultView}`, { replace: true })
  //   } else {
  //     navigate(0)
  //   }
  // }

  return (
    <div className="card">
      <div className="card-header bg-success-subtle">
        <div className="d-flex justify-content-between align-items-center">
          <h4 className="mb-0 text-success">
            Case {caseId} FAM/Office Note
          </h4>

          {add_note && (
            <button className="btn btn-green btn-sm fw-bold" onClick={() => setNoteModalVisibility(true)}>
              <i className="fas fa-times"></i>{' '}Add Note
            </button>
          )}
        </div>
      </div>

      <div className="card-body">
        <div className="container-fluid case-notes-listing">
          {kamfamNotes.length > 0 &&
            kamfamNotes.map((item, index) => {
              const isOffice = item.type.toLowerCase().replace(/note/g, '').trim() === "office"
              const isFam = item.type.toLowerCase().replace(/note/g, '').trim() === "fam"
              const noteColor = isOffice ? "btn-office" : isFam ? "btn-fam" : "";


              return (
                (isManufacturer ) ? (
                  <div
                    className={`row mb-2 py-1 align-items-center ${index % 2 === 0 ? "bg-secondary-subtle" : ""
                      }`}
                    key={index}
                  >
                    <div className="col-12 col-md-3">
                      <p className="mb-0 fs-6 text-start">
                        {item?.user || item?.name}
                      </p>
                    </div>

                    <div className="col-12 col-md-9">
                      <p className={`mb-0 fs-6 ${noteColor}`}>
                        {item?.description || ""}
                      </p>
                    </div>

                    <div className="col-12 text-start pt-1">
                      <p className="mb-0 fs-6">
                        {item?.date || item?.created_at}
                      </p>
                    </div>
                  </div>
                ): ( !item?.description.includes ("No FAM Action Needed")) && ( <div
                    className={`row mb-2 py-1 align-items-center ${index % 2 === 0 ? "bg-secondary-subtle" : ""
                      }`}
                    key={index}
                  >
                    <div className="col-12 col-md-3">
                      <p className="mb-0 fs-6 text-start">
                        {item?.user || item?.name}
                      </p>
                    </div>

                    <div className="col-12 col-md-9">
                      <p className={`mb-0 fs-6 ${noteColor}`}>
                        {item?.description || ""}
                      </p>
                    </div>

                    <div className="col-12 text-start pt-1">
                      <p className="mb-0 fs-6">
                        {item?.date || item?.created_at}
                      </p>
                    </div>
                  </div>)
              );

            })
          }
        </div>
      </div>

      <AddNote
        isModalVisible={isNoteModalVisible}
        caseId={caseId}
        refreshListing={(note) => refreshListing()}
        hideModal={() => setNoteModalVisibility(false)}
      />
    </div>
  )
}

export default KAMFAMNotes;
